// Regroupe des items par clé (helper générique, utilisé par les 3 modules pour grouper par marque/site).
export function groupBy<T, K>(items: T[], keyOf: (item: T) => K): Map<K, T[]> {
    const grouped = new Map<K, T[]>()

    for (const item of items) {
        const key = keyOf(item)
        const existing = grouped.get(key)
        if (existing) {
            existing.push(item)
        } else {
            grouped.set(key, [ item ])
        }
    }

    return grouped
}

/**
 * Fusionne les sites qui partagent une config strictement identique (même signature) en une
 * seule ligne ("N sites"), et isole les sites qui divergent (nom du site affiché).
 */
export function buildSiteLabelGroups<T>(
    siteItems: Array<{ dealershipId: number, signature: string, value: T }>,
    siteNameById: Map<number, string>,
): Array<{ siteLabel: string, dealershipIds: number[], value: T }> {
    const groupedBySignature = groupBy(siteItems, item => item.signature)

    return Array.from(groupedBySignature.values()).map(group => {
        const dealershipIds = group.map(item => item.dealershipId)
        const siteLabel = dealershipIds.length > 1
            ? `${dealershipIds.length} sites`
            : (siteNameById.get(dealershipIds[0]) ?? `Site ${dealershipIds[0]}`)

        return { siteLabel, dealershipIds, value: group[0].value }
    })
}
